/**
 * Injeta dinamicamente um script no documento para fins de fingerprinting.
 * @param target Objeto global, tipicamente `window`.
 * @param doc Documento onde o script será injetado.
 * @param tagName Nome da tag para criação do elemento, geralmente 'script'.
 * @param src URL do script a ser injetado.
 * @param objectName Nome do objeto a ser usado para o fingerprinting.
 * @param scriptElement (Opcional) Elemento de script existente.
 * @param insertBeforeElement (Opcional) Elemento antes do qual o novo script será inserido.
 */

import { env } from 'next-runtime-env';

export const HTML_INJECT_FINGERPRINT = `
function fingerPrint(a, b, c, d, e, f, g) {
  a['CsdpObject'] = e;
  a[e] = a[e] || function () {
    (a[e].q = a[e].q || []).push(arguments);
  };
  a[e].l = 1 * new Date();
  f = b.createElement(c);
  g = b.getElementsByTagName(c)[0];
  f.async = 1;
  f.src = d;
  g.parentNode.insertBefore(f, g);
}
`;

interface CheckoutInstance {
  organization: string;
  account_settings: {
    merchant_id: string;
  };
}

declare global {
  interface Window {
    fingerPrint: (
      w: Window,
      d: Document,
      s: string,
      url: string,
      csdp: string
    ) => void;
    csdp: (param: string, value: string) => void;
  }
}

export function initialFingerprint(
  checkoutInstance: CheckoutInstance,
  antifraudId: string
): void {
  const FINGERPRINT_ID = env('NEXT_PUBLIC_FINGERPRINT_APP_ID');
  const MERCHANT_LIST = env('NEXT_PUBLIC_FINGERPRINT_MERCHANT_WHITE_LIST');

  if (!FINGERPRINT_ID) {
    console.warn('Fingerprint App ID not found');
    return;
  }
  if (!MERCHANT_LIST) {
    console.warn('Fingerprint Merchant White List not found');
    return;
  }
  if (!checkoutInstance?.account_settings?.merchant_id) {
    console.error('Antifraud ID or Merchant ID not found');
    return;
  }

  if (typeof window !== 'undefined') {
    sessionStorage.setItem('antifraud_id', antifraudId);

    const merchantList = MERCHANT_LIST.split(';');
    if (
      merchantList.includes(checkoutInstance.account_settings.merchant_id) ||
      checkoutInstance.organization === 'ton'
    ) {
      window.fingerPrint(
        window,
        document,
        'script',
        'https://device.mundipagg.com/p/fp.js',
        'csdp'
      );
      window.csdp('app', FINGERPRINT_ID);
      window.csdp('sessionid', antifraudId);
    }
  }
}
